/* tslint:disable */
import { CompanyEInvoiceHilo } from './company-einvoice-hilo';

/**
 */
export class CompanyEInvoice {
    active?: boolean;
    data?: CompanyEInvoiceHilo;
}
